<app-module-header [title]="(organization?.organizationName ? $safeNavigationMigration(organization?.organizationName) + ' - ' : '') + ('FINANCE.TITLE' | transloco)"
icon="account_balance_wallet"></app-module-header>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate" class="mb-2"></mat-progress-bar>
}

<mat-tab-group dynamicHeigh syncTabsWithUrl>
  <mat-tab [label]="'TRANSACTION.PAGINATED_TRANSACTION_LIST' | transloco" urlKey="page-list">
    <app-transaction-list-paginated [isLoading]="isLoading" (incrementRequests)="incrementRequests()"
    (decrementRequests)="decrementRequests()" [organization]="organization"></app-transaction-list-paginated>
  </mat-tab>
  <!-- <mat-tab [label]="'TRANSACTION.GRAPH' | transloco">
  <div class="finance-dashboard mt-2">
    <div class="dashboard-item dashboard-transactions">
      <div class="dashboard-header">
        <div class="header-left">
          <mat-icon class="">trending_up</mat-icon>
          <h3>Transaction Analytics</h3>
        </div>
      </div>
      <div class="chart-container">
        <canvas baseChart [data]="transactionLineChartData" [options]="transactionLineChartOptions"
        [type]="'line'"></canvas>
      </div>
    </div>
  </div>
</mat-tab> -->
<mat-tab [label]="'TRANSACTION.TRANSACTIONS' | transloco" urlKey="list">
  <app-transaction-list [isLoading]="isLoading" (incrementRequests)="incrementRequests()"
  (decrementRequests)="decrementRequests()" [organization]="organization"></app-transaction-list>
</mat-tab>
</mat-tab-group>
